<template>
  <h3 class="iconTitle" :class="{orange: theme == 'orange', blue: theme == 'blue'}">
    {{text}}
    <div class="separator" v-if="hasBlock">
    </div>
  </h3>
</template>

<script>
export default {
  name: 'bigTitle',
  props: ['text', 'hasBlock', 'theme']
}
</script>

<style lang="scss">

.iconTitle {
  font-size: rem(26px);
  line-height: rem(30px);
  font-weight: 600;
  margin: 0;
  position: relative;

  @include mq($until: MD) {
    font-size: rem(22px);
    line-height: rem(26px);
  }

  .separator {
    position: relative;
    margin-bottom: rem(25px);
    padding-top: rem(25px);

    &::after {
      content: '';
      width: 100%;
      position: absolute;
      height: 1px;
      left: 0;
      background-color: color(grey-light);
    }
  }
}
</style>
